import ProjectView from "../../project-view"
import ProjectViews from "../../project-views"
import ApiDocument from "../../../../gd/api/document"
import {ProjectView_Page_AccessControl} from "./acl"
import {ProjectViewConfig} from "../../@types";

export default class ProjectView_Page extends ProjectView {

    // Special View properties
    public documentId?  : ID

    constructor(viewConfig:ProjectViewConfig, projectViews:ProjectViews) {
        super(viewConfig, projectViews)

        // Specific properties
        this.documentId     = _.get(this.config, 'documentId', undefined)
    }

    get acl():ProjectView_Page_AccessControl {

        if (!this._acl) {
            this._acl = new ProjectView_Page_AccessControl(this)
        }

        return this._acl
    }

    async rename() {
        return new Promise((resolve, reject) => {
            gd.modals.oneInput('Name', this.name, 'Rename', async (newName)=>{
                gd.modal.hide()

                await ApiDocument.update(this.documentId!, {name: newName}).promise()
                resolve(false)
            })
        })
    }

    toJson() {
        const config        = super.toJson()

        config.documentId   = this.documentId

        return config
    }
}